import React from 'react';
import MenuItem from 'components/MenuItem';
import messages from 'containers/MRhDashboard/messages';
import { injectIntl, IntlShape } from 'react-intl';
import PAGES from 'routes/pages';
import { translate } from 'helpers/intl';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
const ActionButtons = (props: {
  intl: IntlShape;
  setDetailsPageBreadcrumbsPath: Function;
  openModalServicesMrh: Function;
}) => (
  <React.Fragment>
    <MenuItem
      setDetailsPageBreadcrumbsPath={props.setDetailsPageBreadcrumbsPath}
      openServices={props.openModalServicesMrh}
      items={[
        {
          title: translate({ ...messages.que_faire_en_cas_sinistre }, props),
          icon: 'ReclamationIconMRH',
          path: PAGES.RECLAMATION,
          openModalServices: true,
          smalIcon: true,
          category: EVENT_CATEGORIES.MRH_ACCUEIL,
          label: 'AG_Que faire en cas de sinistre ?',
        },
        {
          title: translate({ ...messages.Suivre_sinitre }, props),
          icon: 'timeline_mrh',
          path: PAGES.MRH_DETAILS,
          openModalServices: false,
          BreadcrumbsPath: [
            {
              name: 'habitation',
              route: PAGES.MRHDASHBOARD,
            },
            {
              name: 'suiviDeSinistre',
            },
          ],
          category: EVENT_CATEGORIES.MRH_ACCUEIL,
          label: 'AG_Suivre mes sinistres',
        },
        {
          title: translate({ ...messages.title_contracts_garanties }, props),
          icon: 'ContractGarantieMRH',
          path: PAGES.MRH_DETAILS,
          openModalServices: false,
          BreadcrumbsPath: [
            {
              name: 'habitation',
              route: PAGES.MRHDASHBOARD,
            },
            {
              name: 'contractEtGarantie',
            },
          ],
          category: EVENT_CATEGORIES.MRH_ACCUEIL,
          label: 'AG_Contrats et garanties',
        },
      ]}
    />
  </React.Fragment>
);

export default injectIntl(ActionButtons);
